import React, { useContext } from 'react';
import { Formik, Form } from 'formik';
import useFormSubmit from '~/hooks/useFormSubmit';
import * as Yup from 'yup';

import TransContext from '~/contexts/TransContext';
import InputField from '~/components/Forms/Fields/InputField';
import CheckboxField from '~/components/Forms/Fields/CheckboxField';

const validationSchema = Yup.object({
  contact: Yup.object({
    Email: Yup.string().email('Invalid email address').required('Required'),
    FirstName: Yup.string().required('Required'),
    LastName: Yup.string().required('Required'),
    Company: Yup.string().required('Required'),
    Title: Yup.string().required('Required'),
    AcceptTerms: Yup.boolean().oneOf([true], 'This field must be checked'),
    custom: Yup.object({
      'string--DownloadFormIdentifier': Yup.string(),
    })
  })
});

export default function EbookForm({ downloadFormIdentifier = '', setIsSubmitted }) {
  const trans = useContext(TransContext);

  const { post, loading, response } = useFormSubmit({
    url: '/.netlify/functions/autopilot-form',
    setIsSubmitted
  });

  return (
    <Formik
      initialValues={{
        contact: {
          Email: '',
          FirstName: '',
          LastName: '',
          Phone: '',
          Company: '',
          Title: '',
          AcceptTerms: false,
          Newsletter: false,
          custom: {
            'string--DownloadFormIdentifier': downloadFormIdentifier,
          },
        }
      }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        await post(values);
      }}
    >
      {(props) => (
        <Form className="mt-12">
          {/* <pre>{JSON.stringify(props, null, 4)}</pre> */}
          <div className="grid md:grid-cols-1 gap-8">
            <InputField name="contact.Email" type="email" placeholder={trans?.content?.emailPlaceholder} label={trans?.content?.emailLabel}  />
            <InputField name="contact.FirstName" type="text" placeholder={trans?.content?.firstNamePlaceholder} label={trans?.content?.firstNameLabel} />
            <InputField name="contact.LastName" type="text"  placeholder={trans?.content?.lastNamePlaceholder} label={trans?.content?.lastNameLabel} />
            <InputField name="contact.Company" type="text" placeholder={trans?.content?.companyPlaceholder} label={trans?.content?.companyLabel}  />
            <InputField name="contact.Title" type="text" placeholder="Enter your job title" label="Job Title" />
            <input type="hidden" name="string--DownloadFormIdentifier" value={downloadFormIdentifier} />
          </div>

          <div className="mt-8">
            <button
              type="submit"
              className="w-full flex flex-col justify-center bg-blue hover:opacity-80 transition-opacity duration-100"
            >
              <div className="pointer-events-none c-btn c-btn--primary hover:bg-blue mx-auto">Download now</div>
            </button>
          </div>

          <div className="mt-10">
            <CheckboxField
              name="contact.AcceptTerms"
              label={trans?.content?.termsLabel}
            />
            <CheckboxField
              name="contact.Newsletter"
              label={trans?.content?.newsletterLabel}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
